import tw from "twin.macro";

export const SectionHeading = tw.h3`text-4xl sm:text-5xl font-black tracking-wide text-center max-md:text-left`
export const Subheading = tw.span`font-bold text-primary-500 block`
